import { createContext } from 'react';

import type { IPortalLogo } from './types';

// The offer entity's logo, resolved server-side (Onboard::PortalLogo). null shows
// the default Scout Talent logo.
export const PortalLogoContext = createContext<IPortalLogo | null>(null);
